import { COVERT_EN_US } from "#pages/place/settings/couvert/translations";
import { vendor } from "./vendor";

export const settings = {
	title: "Edit settings",
	error: "No permission to edit place",
	alterImage: "Image changed successfully",
	attention: "Attention!",
	url: "productname",
	daysAndWorkingPeriod: "Days and working hours",
	address: {
		postalCode: "Postal Code",
		state: "State",
		city: "City",
		neighborhood: "Neighborhood",
		address: "Address",
		number: "Number",
		complement: "Complement",
	},
	workingPeriod: {
		deletedPeriod: "Period deleted.",
		addDaysAndTime: "Add days and times",
		addOpeningHours: "Add opening hours",
		daysOfTheWeek: "Days of the week",
		start: "Start",
		end: "End",
		errors: {
			timeRequired: "Enter a standard time format",
			daysRequired: "Select at least 1 day",
			endTimeAfterStart: "End time must be greater than start time",
		},
	},
	menu: {
		title: "Other configuration options",
		general: {
			title: "General",
			subtitle: "Inform limits, e-mails and others",
		},
		productsWeb: {
			title: "Web Products",
			subtitle: "Configure Online Tab, Table Order and Delivery Now.",
		},
		record: {
			title: "Record",
			subtitle: "Configure token mode",
		},
		couvert: {
			title: "Couvert",
			subtitle: "Set the cover charge",
		},
		features: {
			title: "Features",
			subtitle: "Enable desired features",
		},
		pdv: {
			title: "PDV",
			subtitle: "Configure the point of sale",
		},
		totem: {
			title: "Totem",
			subtitle: "Customize a totem",
		},
		refundReason: {
			title: "Refund/Cancel Reasons",
			subtitle: "Configure reasons for the point of sale",
		},
		vendor: {
			title: "Vendor",
			subtitle: "Configure general information",
		},
		fiscalPrinter: {
			title: "Fiscal Printers",
			subtitle: "Configure the fiscal printers",
		},
	},
	warningDialog:
		"You are enabling postpaid payments on '{{name}}'. Are you sure about this? To confirm the modification, please type '{{text}}'",
	data: {
		label: "Data",
		name: "Name",
		selectProduct: "Select a product to enable automatic security deposit",
		noneProduct: "No products",
		peopleCapacity: "Capacity",
		slug: "Slug",
		peopleCapacityTooltip: "Number of people the place holds",
	},
	passTemplate: "ID do modelo do passe",
	limits: {
		label: "Limits and services",
		postPaidLimit: "Postpaid limit",
		serviceTax: "Service charge",
		rechargeNotIntegratedLimit: "Non-integrated recharge limit",
		nonIntegratedPaymentLimit: "Non-integrated payment limit per device and event",
		enableBuiltInLimit: "Enable non-integrated recharge limit",
		enableNonIntegratedPaymentLimit:
			"Enable non-integrated payment limit per device and event",
		nonIntegratedPaymentLimitTooltip:
			"This limit refers to the maximum amount of non-integrated payments that a device can receive during the event. This parameter is the sum of total Recharges and Sales without a Card made with non-integrated payments",
		nonIntegratedRechargeLimitTooltip:
			"This limit refers to the maximum amount that an employee can make in a non-integrated recharge",
	},
	settings: {
		label: "Settings",
		myActionsPassword: {
			label: "¨My Actions¨ password",
			placeholder: "Enter a numeric password or the default password will be 9090",
		},
		sellVisualizationFormat: {
			label: "Display format of products on sale",
			grid: "Grid",
			list: "List",
		},
		kdsServer: {
			label: "KDS server IP",
			placeholder: "Enter the IP",
		},
	},
	everest: {
		label: "Everest",
		user: "User",
		password: "Password",
		cnpj: "CNPJ",
		host: "Host",
	},
	placeFeatures: "Functionalities",
	email: "Emails to receive closing events",
	emailError: "Invalid email",
	consumption: {
		label: "Minimum consumption tax setup",
		fiscalProfile: "Fiscal profile",
		fiscalGroup: "Fiscal group",
		ncm: "NCM",
	},
	alert: "Modifications have been made, save to keep them",
	save: "Save",
	image: "Image",
	ficha: {
		label: "Ficha",
		text: "Title of the Form",
		placeholderText: "Insert the form title",
		logo: "Image in the form",
		upload: "Attach image",
		formatError: "Unsupported format",
		imageFormatMessage: "The image must be in PNG or SVG format.",
		recommendationMessage:
			"We recommend that the assigned image be the <strong>company logo</strong> in <strong>black color</strong>, as it is not possible to print in another color.",
		dragOrSelectMessage:
			"Drag the image from your computer or select it from 'Attach image'.",
		logoFormatMessage:
			"The <strong>background of the image/logo must be white</strong> to appear transparent in printing.",
		dimensionsMessage:
			"The suggested dimensions for good resolution are <strong>472x472</strong> px.",
		size: {
			Small: "S - Small",
			Medium: "M - Medium",
			Large: "L - Large",
			NoImage: "No Image",
			NoQRCode: "No QRCode",
			recommend: "recommended",
		},
		fontSize: "Font size",
		imageSize: "Image",
		qrCodeSize: "QR Code size",
	},
	couvertEdit: COVERT_EN_US,
	devices: {
		label: "Place PDVs ({{counter}})",
		placeholder: "Add a PDV to this location",
		requestDevices: "Request devices",
	},
	errors: {
		invalidName: "Please enter a valid name",
		invalidTip: "Enter a value of up to 25%",
		postPaidLimit: "Please enter a valid value",
		rechargeNotIntegratedLimit: "Minimum value of",
		hasConsumptionObligation: "Mandatory field for consumption obligation configuration",
		minNonIntegratedPaymentLimit: "Minimum value of {{value}}",
		tipOptionsValuesRequired: "Tip values are required",
		tipOptionLowerValue:
			'The "Lower Value" must be less than the Medium and Higher values',
		tipOptionHigherValue: 'The "Higher Value" must be greater than the Medium value',
	},
	totem: {
		logoSelectDescription:
			"<strong>Select the logo that best fits your image</strong> (disregard the background color)",
		addLogo: "Add",
		important: "Important",
		instructions: "Recommendations",
		image:
			"The image should have dimensions of <strong>1080 x 1920</strong> px in height",
		logo:
			"The <strong>Zig</strong> logo will appear over the assigned image, centered at the top.",
		recommendations:
			"It is recommended to insert the message <strong>'tap to start'</strong> to guide the user",
		defaultMessage:
			"If you don't add a cover image, " +
			"Zig's default screen will be your home screen " +
			"(see the first image under <strong>'Colors'</strong>.)",
		totemImgLabel: "Home screen image (optional)",
		totenCustomizationLabel: "Totem Cover Customization",
		removeTotemImage: {
			title: "Do you want to delete the home screen?",
			content: "By deleting it, the home screen will revert to Zig's default screen.",
			confirmBtn: "Yes, I want to delete",
			cancelBtn: "No",
		},
		colors: "Colors",
		saveMessage: "Save customization",
	},
	tip: {
		taxType: "Tax Type",
		tipSuggestions: "Tip Suggestions",
		tip: "Tip",
		serviceTax: "Service Charge",
		none: "None",
		lowerValue: "Lower Value",
		medValue: "Medium Value",
		higherValue: "Higher Value",
		tooltip:
			"Tip recommendations make paying the bill easier by offering three percentage options (Smaller, Medium, and Larger) based on the total amount of the bill, for example: 5%, 10%, and 15%, capped at 25%.",
	},
	authKeysFeature: {
		phone: "Phone",
		email: "Email",
		keySelectLabel: "Choose the key type",
		addKey: "Add Authentication Keys",
		contactsInputLabel: "Add one or more keys for authentication",
		contactsEmailInputPlaceholder: "Enter a valid email (e.g: emailname@gmail.com)",
		contactsPhoneInputPlaceholder: "Enter a phone number (e.g: +55 (00) 0 00000000",
		btnAddKey: "Add authentication keys",
		btnCancelAddKey: "Cancel",
		authKeyAreaTitle: "Withdrawal authentication",
		authKeyAreaSubtitle:
			"Register keys (email or phone) that will be used to receive the authentication code when requesting a withdrawal.",
		selectContactKeyMessage: "Select a key type",
		selectContactInputMessage: "Fill in a contact key",
		contactAlreadyExists: "This contact already exists!",
		invalidEmail: "Invalid email",
		invalidPhone: "Invalid phone. Must contain DDI (e.g: +5511999999999)",
		incompletePhone: "Incomplete phone number. Enter all digits.",
		invalidDDI:
			"Only Brazilian phone numbers are accepted. Use DDI +55 or leave it blank.",
		errorCreatingAuthKeys: "Error creating authentication keys",
		invalidContactsFound: "Invalid contacts found. Check the data and try again.",
		errorCreatingSomeKeys: "Error creating some keys: {{errors}}",
	},
	vendor,
	invoiceMoment: {
		fieldLabel: "Select the moment for cashless invoice issuance",
		tip:
			"Select the timing of the invoice issuance for Cashless payments. For all other payment methods that are not Cashless, the invoice will always be issued upon consumption",
		recharge: "Recharge",
		rechargeAndActivation: "Recharge and activation",
		consumption: "Consumption",
		consumptionAndActivation: "Consumption and activation",
	},
	refundReason: {
		addReason: "Create new reason",
		cancel: "Cancellation",
		modalDelete: {
			confirmation:
				"Do you want to remove the reason from the list of refund and cancellation reasons?",
			description:
				"By removing the reason, it will no longer appear, but it will remain in old reports.",
			title: "Remove reason",
		},
		modalForm: {
			addReason: "Create Reason",
			allowOpenText: "Enable justification",
			creatingReason: "Creating a reason",
			editReason: "Save changes",
			editingReason: "Editing a reason",
			reason: "Reason name",
			reasonPlaceholder: "Enter the name for the refund and/or cancellation reason",
		},
		reason: "Reason name",
		removeReason: "Edit reason",
		refund: "Refund",
		table: {
			editReason: "Edit reason",
			observation: "Observation",
			reason: "Reason name",
			removeReason: "Remove reason",
			status: "Status",
			type: "Type",
		},
		title: "Refund and Cancellation Reasons",
	},
	fiscalPrinter: {
		title: "Fiscal Printers",
		name: "Name",
		type: "Type",
		ip: "IP",
		actions: "Actions",
		deletedSuccessfully: "Printer deleted successfully",
		addedSuccessfully: "Printer added successfully",
	},
	defaultDateFilter: "Default date filter",
	productsWeb: {
		title: "Web Products",
		subtitle:
			"Configure the link and other information for Delivery Now and Table Order.",
		saveChanges: "Save changes",
		toastSuccess: "Settings saved successfully",
		toastError: "Could not save changes, please try again.",
		availableTimeTitleDrawer: "Add days and hours",
		deleteOperatingHoursModal: {
			title: "Delete operating hours",
			descriptionPrefix: "When deleted, the days and times ",
			descriptionBold: "will not be",
			descriptionSuffix: " displayed anymore {{location}}.",
			cancel: "Cancel",
			confirm: "Delete hours",
		},
		tabs: {
			general: "General Information",
			entregueja: "Delivery Now",
			namesa: "Table Order",
			comanda: "Online Tab",
		},
		availableTime: {
			addRangeTime: "Add time",
			addDaysAndTime: "Add days and hours",
			rangeTime: {
				from: "From",
				to: "To",
				startTimeLabel: "Start",
				endTimeLabel: "End",
			},
			daysOfTheWeekTitle: "Days of the week",
			daysOfTheWeekSubtitle: "Select the days of the week the establishment operates.",
			rangeTimeTitle: "Hours",
			rangeTimeSubtitle: "Select the operating hours for the establishment.",
			holidaysTitle: "Holidays",
			holidaysSubtitle:
				"Define the operating hours of the establishment during holidays.",
		},
		timeSection: {
			title: "Average time",
			subtitle: "Define information such as average time to be displayed to the customer",
			averageAwaitTimeLabel: "Average waiting time",
			visibleInfoLabel: "Make visible",
			isWaitingTimeVisibleLabel: "Average waiting time",
			isOpenStatusVisibleLabel: "Status (open or closed)",
		},
		paymentMethodsSection: {
			title: "Payment methods",
			subtitle:
				"Select the methods the customer can use to pay on the website or upon delivery.",
		},
		deliveryTaxSection: {
			title: "Delivery Fee",
			subtitle: "Define delivery fee information to be displayed to the customer.",
			attendanceRadiusLabel: "Service radius",
			deliveryTaxTypeLabel: "Fee type",
			deliveryFeeLabel: "Charged delivery fee",
			fixedDeliveryFeeLabel: "Base amount",
			deliveryFeePerKmLabel: "Amount per km",
			perKmLabel: "Base amount",
			valueLabel: "Amount per km",
			addMoreTax: "Add another fee",
			deliveryTaxType: {
				unique: "Single",
				baseRateWithVariableKm: "Base fee + variable",
				ratePerRadius: "Rate per radius",
			},
		},
		generalTab: {
			productsLabel: "Web Products",
			productsSubtitle: "Check the list of web products to be configured.",
			urlLabel: "URL address",
			urlSubtitle:
				"Define the access URL for the Digital Menu, Delivery Now, Table Order, and Online Tab.",
			slugInvalid:
				"The slug must contain only letters, numbers, hyphens, and underscores",
			barLabel: "Bar linking",
			barSubtitle:
				"Define which bar the menus created through delivery integration will be linked to.",
			selectBarLabel: "Select a bar",
			selectBarTooltip:
				"It is only possible to link one bar to menus created from integrations",
			save: "Save Changes",
			tagInfo: {
				entregueja: "Delivery",
				namesa: "Prepaid",
				comanda: "Postpaid",
				cardapio: "View",
			},
		},
		entregueja: {
			availableTimesSection: {
				title: "Operating hours",
				subtitle: "Define the operating days and hours for Delivery Now",
				deleteModalLocation: "in Delivery Now",
			},
		},
		namesa: {
			availableTimesSection: {
				title: "Operating hours",
				subtitle: "Define the operating days and hours for Table Order",
				deleteModalLocation: "in Table Order",
			},
		},
		comanda: {
			availableTimesSection: {
				title: "Operating hours",
				subtitle: "Define the operating days and hours for Online Tab",
				deleteModalLocation: "in Online Tab",
			},
		},
		establishmentAddress: {
			title: "Establishment address",
			subtitle: "Establishment address information",
			warningTitle: "Attention",
			warningMessage:
				"The displayed address fields are for reference only. To change them, please contact our support team.",
			postalCode: "ZIP Code",
			state: "State",
			city: "City",
			neighborhood: "Neighborhood",
			street: "Street",
			number: "Number",
			complement: "Complement",
			complementPlaceholder: "Ex: store A",
		},
		establishmentContactSection: {
			title: "Establishment contact",
			subtitle: "Enter the phone number for customers to contact",
			phoneLabel: "Phone number",
			invalidPhone:
				"Enter the number with country code (10 to 15 digits). E.g. +55 71 999991234",
		},
	},
};
